export default __webpack_public_path__ + "static/media/00_drevorubec.5e0a0fe5.jpg";